<!--
@负责人: libaiqi
@创建时间: 2019-01-02
@版本:v2.0.0
@描述: 导航设置
-->
<template>
  <div class="navigationSetting__content">
    <div class="navigationSetting__form">
      <el-form ref="form" :model="form" :inline="true" input-width="auto">
        <el-form-item :label="$t('navigationSetting.name')">
          <el-input v-model="form.name" ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="e_search" v-g-rac="gRac('navigationSetting@search')">{{ $t('common.search') }}</el-button>
          <el-button type="primary" @click="e_add()" v-g-rac="gRac('navigationSetting@add')">{{ $t('common.add') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="navigationSetting__site" v-show="siteData.length > 0">
      <div v-for="(item,index) in siteData" :key="index" class="navigationSetting__site--single" v-g-rac="gRac('navigationSetting@update')">
        <i class="icon iconfont icon-amc_circle_close icon-delete" @click="e_delete(item)" v-g-rac="gRac('navigationSetting@delete')"></i>
        <span class="navigationSetting__site--web" v-text="item.name" @click="e_add(item)" :title="item.name"></span>
        <div class="navigationSetting__site--name" v-text="item.name" @click="e_add(item)"></div>
      </div>
    </div>
    <div class="navigationSetting__noData" v-show="siteData.length === 0">
      {{$t('navigationSetting.noDAta')}}
    </div>
    <dialog-form
      key="navigationForm"
      :title="dialogTitle" 
      :size="1" 
      :label-size="2" 
      :visible.sync="dialogFormShow" 
      :model="dialogModel"
      :input-data="dialogData"
      :rules="dialogFormRule"
      :confirm-fun="e_save">
    </dialog-form>
  </div>
</template>
<script>
  import rac from '@/plugins/rac-mixin'
  import navigationSettingBiz from '@/logic/intelligentMonitor/navigationSettingBiz'
  import dialogForm from '@/components/dialogForm'
  import validateConfig from '@/utils/validate'

  export default {
    mixins: [rac],
    data () {
      return {
        form: {
          name: ''
        },
        dialogTitle: '',
        dialogModel: {},
        dialogData: [],
        dialogFormRule: {},
        dialogFormShow: false,
        siteData: []
      }
    },
    components: {
      dialogForm
    },
    methods: {
      setDialogData () {
        this.dialogData = [
          {
            label: this.$t('navigationSetting.name'),
            key: 'name'
          },
          {
            label: this.$t('navigationSetting.location'),
            key: 'location'
          }
        ]
        this.dialogData.map((item) => {
          if (item.key !== 'defaultIndex' && item.key !== 'rewrite') {
            this.dialogFormRule[item.key] = [{ ...validateConfig.common.notEmpty }]
          }
        })
      },
      e_search () {
        navigationSettingBiz.getSite(this.form).then((data) => {
          this.siteData = data
        })
      },
      e_add (data) {
        this.dialogFormShow = true
        this.dialogTitle = data ? this.$t('common.edit') : this.$t('common.add')
        this.dialogModel = data ? {
          name: data.name,
          location: data.location,
          id: data.id
        } : {
          name: '',
          location: ''
        }
      },
      e_save () {
        if (this.dialogTitle === this.$t('common.edit')) {
          navigationSettingBiz.updateSite(this.dialogModel).then(() => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            this.dialogFormShow = false
            this.e_search()
          })
        } else {
          navigationSettingBiz.addSite(this.dialogModel).then(() => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            this.dialogFormShow = false
            this.e_search()
          })
        }
      },
      e_delete (data) {
        this.$confirm(this.$t('common.deleteTips'), this.$t('common.tips'), {
          type: 'warning'
        }).then(() => {
          navigationSettingBiz.deleteSite({
            id: data.id
          }).then((data) => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            this.e_search()
          })
        }).catch(() => {

        })
      }
    },
    mounted () {
      this.e_search()
      this.setDialogData()
    }
  }
</script>
<style scoped>
  .navigationSetting__site {
    width: 100%;
    margin-top: 10px
  }
  .navigationSetting__site--single {
    width: 200px;
    height: 80px;
    line-height: 75px;
    text-align: center;
    display: inline-block;
    position: relative;
    cursor: pointer;
    border: 1px solid #9dd1f5;
    font-size: 20px;
    margin-right: 20px;
    margin-bottom: 40px;
    background: #e7f4fc;
    color: #0B8DE5;
    border-radius: 4px;
  }
  .navigationSetting__site--single:hover {
    background: #0B8DE5;
    border-color: #0B8DE5;
    color: #fff;
  }
  .navigationSetting__site--single:hover .navigationSetting__site--name{
    color: #0B8DE5;
  }
  .navigationSetting__site--single .navigationSetting__site--web {
    display: inline-block;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .navigationSetting__site--single .navigationSetting__site--name {
    line-height: 0;
    font-size: 16px;
  }
  .navigationSetting__site--single:hover .icon-delete {
    display: block;
  }
  .navigationSetting__site--single .icon-delete {
    display: none;
    color: #666;
    font-size: 18px;
    position: absolute;
    top: -8px;
    right: -8px;
  }
  .navigationSetting__site--single .icon-delete:hover {
    color: #FF4949;
  }
  .navigationSetting__noData {
    text-align:  center;
    font-size: 16px;
    font-weight: 600;
    margin-top: 10px;
  }
</style>